import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import pieesLogoUrl from './pieeslogo.png'; // Same file used by the header logo

// ─── Set the EXACT same logo as the header into the browser tab favicon ───────
// Webpack bundles pieeslogo.png and gives it a proper hashed URL at high res.
const setFavicon = () => {
  // Remove stale favicon links (favicon.ico / any old link tags)
  document.querySelectorAll("link[rel*='icon']").forEach(el => el.remove());

  // 32×32 favicon (standard browser tab size)
  const link32 = document.createElement('link');
  link32.rel = 'icon';
  link32.type = 'image/png';
  link32.sizes = '32x32';
  link32.href = pieesLogoUrl;
  document.head.appendChild(link32);

  // 180×180 Apple touch icon (home screen on iOS)
  const linkApple = document.createElement('link');
  linkApple.rel = 'apple-touch-icon';
  linkApple.sizes = '180x180';
  linkApple.href = pieesLogoUrl;
  document.head.appendChild(linkApple);
};
setFavicon();
// ─────────────────────────────────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
